/* eslint-disable jsx-a11y/alt-text */
import React from 'react'

const IframeElement = ( props ) => {
  const { styles, content } = props.item.content
  
  return (
    <img 
      src={content.src || 'https://blog.builderall.com/assets/logo.svg'}
      style={styles} 
    />
  )
}


export default IframeElement


// WEBPACK FOOTER //
// ./src/components/commons/editor/IframeElement.js